import type React from 'react';
import { forwardRef, useRef } from 'react';

import classnames from 'classnames';

import Button, { type ButtonProps } from '../../../button/button';

import styles from './file_button.module.css';

type Props = {
  name?: string;
  accept?: string;
  message?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  style?: HTMLStyleElement;
  multiple?: boolean;
  buttonProps?: ButtonProps;
};

const FileButton = forwardRef<HTMLInputElement, Props>((props, ref) => {
  const localRef = useRef<HTMLInputElement>(null);
  const inputRef = ref || localRef;

  const {
    message,
    name,
    accept,
    onChange,
    multiple,
    className,
    buttonProps = {},
  } = props;

  return (
    <div className={classnames(styles.root, className)}>
      <Button
        {...buttonProps}
        onClick={(event) => {
          if ('current' in inputRef && inputRef.current) {
            inputRef.current.click();
          }
          buttonProps.onClick?.(event);
        }}
      >
        {message}
      </Button>
      <input
        ref={inputRef}
        name={name}
        type="file"
        accept={accept}
        onChange={onChange}
        multiple={multiple}
      />
    </div>
  );
});

export default FileButton;
